<template>
  <div class="container">
    <a-menu mode="horizontal" :selectedKeys="current" class="menu">
      <a-menu-item v-for="item in menuList" :key="item.key || item.text">
        <router-link :to="item.path">{{ item.text }}</router-link>
      </a-menu-item>
    </a-menu>
    <div class="content-wrapper">
      <router-view></router-view>
    </div>
  </div>
</template>
<style lang="less" scoped>
.menu {
  display: flex;
  justify-content: center;
  border: none;
  @media only screen and (min-width: 800px) {
    margin-bottom: 50px;
  }
}
.content-wrapper {
  @media only screen and (max-width: 800px) {
    padding: 20px;
    width: 100%;
  }
  @media only screen and (min-width: 800px) {
    width: 80%;
    margin: 0 auto;
  }
}
</style>
<script>
import { humint } from '@/router/humint.js';
export default {
  data() {
    return {
      // current: [],
      // menuList: [
      //   {
      //     key: '1',
      //     text: '人物',
      //   },
      //   {
      //     key: '2',
      //     text: '事件',
      //   }
      // ],
    };
  },
  computed: {
    menuList() {
      return humint.children
        .filter(i => i.name)
        .map(item => {
          let path = item.path;
          if (path[0] !== '/') {
            path = humint.path + '/' + item.path;
          }
          return {
            key: path,
            path: path,
            text: item.name
          };
        });
    },
    current() {
      return this.menuList
        .filter(item => {
          return new RegExp('^' + item.path).test(this.$route.path);
        })
        .map(item => {
          return item.key;
        });
      //
    }
  }
};
</script>
